// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParamBlockWrapper_wrapper__2gWJo","title":"ParamBlockWrapper_title__FDx-D","itemsWrapper":"ParamBlockWrapper_itemsWrapper__2YyNh"};